import type { FunctionComponent } from 'react'

import { Text } from '../../components/text'
import type { BannerFragment } from '../../graphql/fragments/BannerFragment.graphql'
import { asCSSVariable } from '../../types/color'
import styles from './banner.module.scss'

/**
 * A component that displays large heading text in a small thin banner.
 * Optional background image and cta button.
 */
const Banner: FunctionComponent<Omit<BannerFragment, 'type' | 'sys'>> = ({
    copy,
    image,
    color,
}) => {
    return (
        <div
            className={styles.banner}
            style={color && { background: asCSSVariable(color) }}
        >
            {image && (
                <img src={image.source2x} className={styles.background} />
            )}
            <Text
                typeStyle={{
                    _: 'body-2xl',
                }}
                className={styles.copy}
            >
                {copy}
            </Text>
        </div>
    )
}

export default Banner
